import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@ais-ui/ui-core';

export interface StatusCardProps {
  title: string;
  icon: React.ReactNode;
  value: string | number;
  description?: string;
  severity: 'low' | 'medium' | 'high';
}

export const StatusCard: React.FC<StatusCardProps> = ({
  title,
  icon,
  value,
  description,
  severity,
}) => (
  <Card
    className={
      severity === 'high'
        ? 'bg-red-400'
        : severity === 'medium'
          ? 'bg-yellow-400'
          : ''
    }
  >
    <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
      <CardTitle className="text-sm font-medium">{title}</CardTitle>
      {icon}
    </CardHeader>
    <CardContent>
      <div className="text-2xl font-bold">{value}</div>
      {description && (
        <p className="text-xs text-muted-foreground">{description}</p>
      )}
    </CardContent>
  </Card>
);
